import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { Subject, takeUntil } from 'rxjs';
import { CookieConsentService } from '../../services/cookie-consent.service';

@Component({
    selector: 'app-cookie-banner',
    templateUrl: './cookie-banner.component.html',
    styleUrls: ['./cookie-banner.component.scss'],
    standalone: true,
    imports: [CommonModule, RouterLink, TranslateModule],
})
export class CookieBannerComponent implements OnInit, OnDestroy {
    showBanner = false;
    private readonly destroy$ = new Subject<void>();

    constructor(private readonly cookieConsentService: CookieConsentService) {}

    ngOnInit(): void {
        this.cookieConsentService.showBanner$.pipe(takeUntil(this.destroy$)).subscribe((show) => {
            this.showBanner = show;
        });
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    async acceptCookies(): Promise<void> {
        await this.cookieConsentService.acceptCookies();
    }

    async rejectCookies(): Promise<void> {
        await this.cookieConsentService.rejectCookies();
    }
}
